// Animation timing configuration
export const ANIMATION_DELAYS = {
  header: 0,
  subheader: 0.4,
  grayBox: 0.8,
  grayCounter: 0.6,
  purpleBox: 1.0,
  purpleCounter: 1.1,
  buttons: 1.0,
  particles: 1.2,
  badge: 1.1, // relative to particles (was 0.3, now 0.3 + 0.8 = 1.1)
};

export const ANIMATION_DURATIONS = {
  header: 0.6,
  box: 0.7,
  counter: 1.2,
  grayCounterTotal: 2.9,
  particle: 1.6,
};
